import { Box, Fade, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100vh',
    display: 'grid !important',
    [theme.breakpoints.down('sm')]: {
      placeItems: 'unset',
    },
    justifyContent: 'center',
    background: '#F3EFFF',
  },
  itemContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '48px',
  },
  logoContainer: {
    width: '190px',
    height: '45px',
    margin: 'auto',
  },
  logo: {
    width: '100%',
    height: '100%',
  },
  formContainer: {
    marginTop: '30px',
    borderRadius: '12px !important',
    padding: '42px',
    [theme.breakpoints.down('sm')]: {
      padding: '30px',
      boxShadow: 'none',
    },
    boxShadow: 'none',
    // boxShadow: '10px -10px 43.2px 0px #4012CB0F',
    backgroundColor: '#fff',
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#333333',
  },
  text: {
    textAlign: 'center',
    color: '#333333',
  },
  footer: {
    display: 'flex',
    gap: 10,
    paddingTop: '24px',
    margin: 'auto',
    marginBottom: '24px',
  },
}));

export default function AuthFormLayout({
  children,
  title,
  subtitle,
  text,
  hideLogo,
  maxWidth,
  extraComponent,
}) {
  const classes = useStyles();
  return (
    <Box className={classes.pageContainer}>
      <Box className={classes.itemContainer} sx={{ maxWidth: maxWidth || '500px' }}>
        {!hideLogo && (
          <Box className={classes.logoContainer}>
            <img src="/Qualz-logo.png" alt="Qualz logo" className={classes.logo} />
          </Box>
        )}
        {extraComponent && extraComponent}

        <Fade in={true} timeout={1000} className={classes.formContainer}>
          <Box>
            {(title || subtitle || text) && (
              <Stack spacing={{ xs: 1, sm: 2, pb: 3 }} direction="column">
                <Typography variant="h4" className={classes.title} sx={{ color: '#333333' }}>
                  {title ?? ''}
                </Typography>

                {subtitle ? (
                  <Typography
                    variant="subtitle1"
                    className={classes.text}
                    sx={{ fontWeight: 600, color: '#333333' }}
                  >
                    {subtitle}
                  </Typography>
                ) : null}

                <Typography
                  variant="body2"
                  className={classes.text}
                  sx={{ paddingBottom: subtitle ? '24px' : '34px', color: '#333333' }}
                >
                  {text ?? ''}
                </Typography>
              </Stack>
            )}
            <Box>{children}</Box>
          </Box>
        </Fade>
      </Box>
      <div className={classes.footer}>
        {/* <Typography variant="body2" color={'grey.400'}>
          Copyright 2024 Qualz.ai. All Rights Reserved
        </Typography> */}
        <Box
          component="a"
          href="https://qualzwebsitestatic.blob.core.windows.net/qualzai/qualzai%20inc.%20-%20Privacy_Policy.pdf"
          target="_blank"
          sx={{ color: 'text.secondary', textDecoration: 'none' }}
        >
          Privacy
        </Box>
        <Box
          component="a"
          href="https://qualzwebsitestatic.blob.core.windows.net/qualzai/qualzai%20inc.%20-%20Website%20Terms%20of%20Use.pdf"
          target="_blank"
          sx={{ color: 'text.secondary', textDecoration: 'none' }}
        >
          Terms
        </Box>
      </div>
    </Box>
  );
}
